import { render } from "./FloatingMessengerButton.vue?vue&type=template&id=387a0c0e&scoped=true"
import script from "./FloatingMessengerButton.vue?vue&type=script&lang=js"
export * from "./FloatingMessengerButton.vue?vue&type=script&lang=js"

import "./FloatingMessengerButton.vue?vue&type=style&index=0&id=387a0c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387a0c0e"]])

export default __exports__